module.exports = __webpack_public_path__ + "images/emails/hero/welcome@2x-961ee256.png";